import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { onError } from '@apollo/client/link/error';
import { ApolloLink } from '@apollo/client/core';
import { ToastService } from '@core/services/ui/toast.service';
import { TranslateService } from '@ngx-translate/core';

const REDIRECT_DELAY_MS = 2000;

@Injectable({
  providedIn: 'root',
})
export class GraphQLErrorLinkService {
  constructor(
    private toast: ToastService,
    private translate: TranslateService,
    private router: Router,
  ) {}

  handleErrors(
    graphQLErrors?: readonly { message: string }[],
    networkError?: unknown,
  ): void {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message }) => {
        if (message.toLowerCase().includes('unauthorized')) {
          this.toast.showError(
            this.translate.instant('GLOBAL.ERRORS.UNAUTHORIZED_TITLE'),
            this.translate.instant('GLOBAL.ERRORS.UNAUTHORIZED_DETAIL'),
          );
          setTimeout(() => this.router.navigate(['/']), REDIRECT_DELAY_MS);
        }
      });
    }

    if (networkError) {
      this.toast.showError(
        this.translate.instant('GLOBAL.ERRORS.NETWORK_TITLE'),
        this.translate.instant('GLOBAL.ERRORS.NETWORK_DETAIL'),
      );
    }
  }

  get link(): ApolloLink {
    return onError(({ graphQLErrors, networkError }) =>
      this.handleErrors(graphQLErrors, networkError),
    );
  }
}
